import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class L10nService {
    public supportedLangs = ['en', 'it', 'ru'];
    public defaultLang = 'en';
    private currentLang: string;

    constructor() {
        this.currentLang = this.extractLangFromPath(window.location.pathname);
    }

    public getCurrentLang() {
        return this.currentLang;
    }

    private extractLangFromPath(path: string): string  {
        let regex = new RegExp(`^/spa/(${this.supportedLangs.join('|')})(/|$)`);
        let match = path.match(regex);
        if (match) {
            return match[1];
        } else {
            return this.defaultLang;
        }
    }
}
